export default __webpack_public_path__ + "static/media/online-shopping.a2f2a092.jpeg";